import React from 'react'
export default function AuthDenied(props){
  return (
    <React.Fragment>
       <div class="alert-message error center large">
          <div><i class="info circle icon"></i></div>
          <div>
            <p style={{'padding-bottom':'3px','font-weight':'800', 'text-transform':'uppercase'}}>Permission Denied</p>
            <p>You do not have the permission to use this Page and perform any actions with it until you have the proper access.</p>
          </div>
       </div>
       <br/>
    </React.Fragment>
  )
}
